<template>
  <div
    :style="{
      background: 'white',
      padding: '24px',
      minHeight: '380px',
    }"
  >
    <!-- <div :style="{ background: 'white', padding: '24px', minHeight: '380px' }">
        <Content/>
      </div> -->
    &nbsp;
    <a-spin :spinning="loading">
      Exp_Hole:<a-tree-select
        v-model="Holevalue"
        style="width: 30%"
        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
        :tree-data="treeDataHole"
        placeholder="Please select"
        tree-default-expand-all
        tree-checkable
        show-search
        allowClear
        :loading="loading"
        @search="handleSearchHoleByName"
        @change="handleChangeHole"
      >
        <span
          v-if="key === '0-0-1'"
          slot="title"
          slot-scope="{ key, Holevalue }"
          style="color: #08c"
        >
          {{ Holevalue }}
        </span>
        <span
          v-elif="disabled === true"
          slot="title"
          slot-scope="{ disabled, Holevalue }"
          style="color: #08c"
          disabled
        >
          {{ Holevalue }}
        </span>
      </a-tree-select>
    </a-spin>

    <br />
    Scale:
    <a-tree-select
      v-model="Scalevalue"
      style="width: 30%; margin-top: 30px"
      :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
      :tree-data="treeDataScale"
      placeholder="Please select"
      tree-default-expand-all
      show-search
      allowClear
    >
      <span
        v-if="key === '0-0-1'"
        slot="title"
        slot-scope="{ key, Scalevalue }"
        style="color: #08c"
      >
        {{ Scalevalue }}
      </span>
      <span
        v-elif="disabled === true"
        slot="title"
        slot-scope="{ disabled, Scalevalue }"
        style="color: #08c"
        disabled
      >
        {{ Scalevalue }}
      </span> </a-tree-select
    ><br /><br /><br />
    Source:
    <!-- <a-tree-select
      v-model="Sourcevalue"
      :disabled="!Holevalue"
      style="width: 30%; margin-top: 30px"
      :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
      :tree-data="treeDataScale"
      placeholder="Please select"
      tree-default-expand-all
      show-search
      allowClear
    >
      <span
        v-if="key === '0-0-1'"
        slot="title"
        slot-scope="{ key, Sourcevalue }"
        style="color: #08c"
      >
        {{ Sourcevalue }}
      </span>
      <span
        v-elif="disabled === true"
        slot="title"
        slot-scope="{ disabled, Sourcevalue }"
        style="color: #08c"
        disabled
      >
        {{ Sourcevalue }}
      </span> </a-tree-select
    ><br /> -->
    <a-select
      :disabled="!Holevalue"
      ref="select"
      v-model="Sourcevalue"
      style="width: 120px"
    >
      <a-select-option value="all">All</a-select-option>
      <a-select-option value="Academic paper">Academic Paper</a-select-option>
      <a-select-option value="LIMS">Janus</a-select-option>
      <a-select-option value="Neptune">Neptune</a-select-option>
      <a-select-option value="Officail Publication"
        >Officail Publication</a-select-option
      >
      <a-select-option value="Pangaea">Pangaea</a-select-option>
    </a-select>
    <div v-show="noHole" class="alert">Please Add Hole!</div>
    <!-- <router-view></router-view> -->
    <stratlist
      v-bind:source="Sourcevalue"
      v-bind:hole="Holevalue"
      v-bind:scale="Scalevalue"
    />
    <!-- <earth/> -->
  </div>
</template>

<script>
import { getAllStratigraphyHole } from '@/api/index';

import Stratlist from '@/components/stratContent/stratlist.vue';
const treeDataHole = [];

const treeDataScale = [
  // {
  //   title: 'GTS2020',
  //   value: 'GTS2020',
  //   key: '1-1',
  // },
  // {
  //   title: 'GTS2012',
  //   value: 'GTS2012',
  //   key: '9',
  // },
  // {
  //   title: 'TSC',
  //   value: 'TSC',
  //   key: '1-2',
  // },
  // {
  //   title: 'NSB',
  //   value: 'NSB',
  //   key: '1-3',
  // },
  {
    title: 'Standard',
    value: 'Standard',
    key: '1-5',
  },
  {
    title: 'Original',
    value: 'Original',
    key: '1-4',
  },
];
const treeDataEvent = [
  {
    title: 'Biostratigraphy',
    value: 'Biostratigraphy',
    key: 'B1',
    children: [
      {
        // value: '17-167',
        // key: '0-0-1',
        // scopedSlots: {
        //   // custom title
        //   title: 'title',
        // },
        title: 'Bio_N',
        value: 'Bio_N',
        key: 'B1-1',
      },
      {
        title: 'Bio_F',
        value: 'Bio_F',
        key: 'B1-2',
      },
      {
        title: 'Bio_R',
        value: 'Bio_R',
        key: 'B1-3',
      },
      {
        title: 'Bio_D',
        value: 'Bio_D',
        key: 'B1-4',
      },
      {
        title: 'Bio_DN',
        value: 'Bio_DN',
        key: 'B1-5',
      },
    ],
  },
  {
    title: 'Magnetostratigraphy',
    value: 'Magnetostratigraphy',
    key: 'M1',
  },
  {
    title: 'Radiochronology',
    value: 'Radiochronology',
    key: 'R1',
  },
  {
    title: 'Chemostratigraphy',
    value: 'Chemostratigraphy',
    key: 'CH1',
  },
  {
    title: 'Cyclostratigraphy',
    value: 'Cyclostratigraphy',
    key: 'Cy1',
  },
];
export default {
  // components: { Stratlist },

  name: 'ageName',
  // components: { earth },
  components: {
    Stratlist,
  },
  data() {
    return {
      Holevalue: [],
      Hole: '22',
      Scalevalue: '',
      Eventvalue: undefined,
      treeDataHole,
      treeDataScale,
      treeDataEvent,
      noHole: undefined,
      stratlist: [],
      str: '',
      loading: false,
      Sourcevalue: 'all',
    };
  },
  mounted() {
    // this.$router.push({
    //   name: 'stratlist',
    //   query: {
    //     hole: '21',
    //     way: 'map',
    //   },
    // });
    this.loading = true;
    getAllStratigraphyHole().then((res) => {
      console.log(res);
      // res.sort(function (a, b) {
      //   // a = a.replace(/[^\d]/g, ' ');
      //   // b = b.replace(/[^\d]/g, ' ');
      //   // return a - b;
      //   // const getNumericPart = (str) => parseInt(str.match(/\d+/)[0], 10);

      //   // // 检查是否以 'C' 开头
      //   // const isCStart = (str) => str.startsWith('C');

      //   // // a 和 b 是否以 'C' 开头
      //   // const aIsCStart = isCStart(a);
      //   // const bIsCStart = isCStart(b);

      //   // // 如果 a 和 b 都以 'C' 开头，则按数字从大到小排序
      //   // if (aIsCStart && bIsCStart) {
      //   //   return getNumericPart(b) - getNumericPart(a);
      //   // }

      //   // // 如果 a 以 'C' 开头，b 不以 'C' 开头，则 a 优先
      //   // if (aIsCStart) return -1;

      //   // // 如果 b 以 'C' 开头，a 不以 'C' 开头，则 b 优先
      //   // if (bIsCStart) return 1;

      //   // // 如果都不以 'C' 开头，则按数字从大到小排序
      //   // return getNumericPart(b) - getNumericPart(a);
      //   const [legA, holeA] = a.split('_');
      //   const [legB, holeB] = b.split('_');

      //   // 排序逻辑
      //   // 1. 根据 leg 排序
      //   const legComparison = legA.localeCompare(legB);
      //   if (legComparison !== 0) return legComparison;

      //   // 2. 根据 hole 排序（去掉后面的字符）
      //   const holeBaseA = holeA.replace(/[A-Z]/g, '');
      //   const holeBaseB = holeB.replace(/[A-Z]/g, '');
      //   const holeComparison = holeBaseA.localeCompare(holeBaseB);
      //   if (holeComparison !== 0) return holeComparison;

      //   // 3. 相同 hole 的情况下，根据后面的字符排序
      //   const suffixA = holeA.slice(holeBaseA.length);
      //   const suffixB = holeB.slice(holeBaseB.length);
      //   const suffixComparison = suffixA.localeCompare(suffixB);

      //   // 4. 相同后缀的情况下，优先级较低的值放后
      //   if (suffixA === '') return 1; // hole 中没有后面字符的优先级较低
      //   if (suffixB === '') return -1;

      //   return suffixComparison;
      // });
      res.map((item) => {
        this.treeDataHole.push({ title: item, value: item });
      });
      // this.treeDataHole.sort
      this.loading = false;
      // this.treeDataHole.push({ title: 'ss', value: 'ss' });
    });
  },
  watch: {},
  methods: {
    showEarth() {
      this.$router.push({
        name: 'earth',
        query: {
          type: 'strat',
        },
        // query:{
        //     id:m.id,
        //     title:m.title
        // }
      });
    },
    // handleChangeHole(value) {
    //   console.log(value, this.Holevalue);
    //   this.Hole = value;
    // },
    // handleChangeScale(value) {
    //   this.Scalevalue = value;
    // },
    showList() {
      this.$router.push({
        name: 'select',
        // query:{
        //     id:m.id,
        //     title:m.title
        // }
      });
    },

    handleChangeHole() {
      this.Sourcevalue = 'all';
    },
    onClose() {
      console.log('s');
    },
    handleSearchHoleByName() {},
  },
};
</script>

<style scoped>
.earth {
  margin: 0 60px;
  justify-content: center;
  justify-items: center;
}
.earth :hover,
.list :hover {
  cursor: pointer;
}
.myicon {
  display: inline-block;
}
.alert {
  margin-top: 20px;
  border-radius: 2px;
  border: 1px solid red;
  padding: 20px;
  background-color: hsl(350, 60%, 98%);
}
</style>
